module.exports = __webpack_public_path__ + "static/img/边15.d55f33a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边15.png
// module id = 1bN+
// module chunks = 2